const SocialWebChannelType = Object.freeze({
  TWITTER: 'TWITTER',
  FACEBOOK: 'FACEBOOK',
  YOUTUBE: 'YOUTUBE',
  INSTAGRAM: 'INSTAGRAM',
  TIKTOK: 'TIKTOK',
  OTHER: 'OTHER'
} as const)
export default SocialWebChannelType
export type SocialWebChannelTypeStrings = typeof SocialWebChannelType[keyof typeof SocialWebChannelType]
// RESERVE BELOW
